import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PartnerResellerMessageCard = () => {
	const { t } = useTranslation("admin");

	return (
		<Card>
			<Card.Body>
				<h5>{t("enums.partner_types.RESELLER")}</h5>
				<div className="mt-2 d-flex flex-column">
					<strong>{t("modules.partner.field.hello.title")},</strong>
					<p className="mb-3">{t("modules.partner.field.document_links.title")}</p>
					<p className="mb-3">{t("modules.partner.field.contact_details.title")}</p>
					<p>Michał Tomkiewicz, tel. 796 706 233, michal.tomkiewicz@gopos.pl</p>
					<p>Jakub Gontarz, tel. 731 039 123, jakub.gontarz@gopos.pl</p>
				</div>

				<div className="mt-2 d-flex flex-column">
					<strong>{t("modules.partner.field.useful_links.title")}</strong>
					<a
						target="_blank"
						rel="noreferrer"
						href="https://docs.google.com/spreadsheets/d/12G_7GRTNlCF9E3IFGBME5MKxSlpmnPValHHq4jU4Czs/edit#gid=0"
					>
						{t("modules.partner.field.price_list.title")}
					</a>
					<a
						target="_blank"
						rel="noreferrer"
						href="https://docs.google.com/spreadsheets/d/1Rofzqs16huzuMsk42650o62Q6v4gjETQoIV_WVUAvLQ/edit#gid=1082454294"
					>
						{t("modules.partner.field.offer_calculator.title")}
					</a>
					<a
						target="_blank"
						rel="noreferrer"
						href="https://drive.google.com/drive/folders/1a91Myuf6sgYHlwXy4bA5YI21Gn_Mgu3y"
					>
						{t("modules.partner.field.commercial_materials.title")}
					</a>
					<a target="_blank" rel="noreferrer" href="https://help.gopos.pl/pl/">
						{t("modules.partner.field.knowledge_base.title")}
					</a>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PartnerResellerMessageCard;
